import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { toDate } from "./toDate.js";
/**
 * The {@link isWithinInterval} function options.
 */

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @param date - The date to check
 * @param interval - The interval to check
 * @param options - An object with options
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * // => true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * // => false
 *
 * @example
 * // For date equal to the interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to the interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */

export function isWithinInterval(date, interval, options) {
  var time = +toDate(date, options === null || options === void 0 ? void 0 : options.in);

  var _sort = [+toDate(interval.start, options === null || options === void 0 ? void 0 : options.in), +toDate(interval.end, options === null || options === void 0 ? void 0 : options.in)].sort(function (a, b) {
    return a - b;
  }),
      _sort2 = _slicedToArray(_sort, 2),
      startTime = _sort2[0],
      endTime = _sort2[1];

  return time >= startTime && time <= endTime;
} // Fallback for modularized imports:

export default isWithinInterval;